import { render } from "./SocialstyrelsenGenericDemographicBaseline.vue?vue&type=template&id=48f0afef&scoped=true"
import script from "./SocialstyrelsenGenericDemographicBaseline.vue?vue&type=script&lang=js"
export * from "./SocialstyrelsenGenericDemographicBaseline.vue?vue&type=script&lang=js"

import "./SocialstyrelsenGenericDemographicBaseline.vue?vue&type=style&index=0&id=48f0afef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f0afef"]])

export default __exports__